import React from 'react';
import RecipientsComponent from '@/containers/CampaignDetail/Recipients/Recipients';

const Recipients: React.FC = () => {
  return <RecipientsComponent subCR />;
};

export default Recipients;
